import React from 'react'
import DataTable from '../../DataTable/DataTable'
import clsx from "clsx"

export default class FolioItemsDashboardFolioItems extends React.Component {
  constructor(props) {
    super(props)

  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "folio_items",
      'tab-pane': true
    });
    
    return(
      <div className={tabClasses} id="folio_items">
        <DataTable endpoint={this.props.folio_items_data_table_path} 
          date_format={this.props.date_format} 
          time_format={this.props.time_format} 
          read_only={this.props.read_only} 
          no_data_text={I18n.t('none')}
          currency_unit={I18n.t('number.currency.format.unit')}
          delimiter={I18n.t('number.currency.format.delimiter')}
          separator={I18n.t('number.currency.format.separator')}
          export_csv_endpoint={this.props.export_csv_endpoint}
         />
      </div>
    )

  }

}
